type Breakpoint = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';

export const breakpoints: Record<Breakpoint, number> = {
  xxs: 0,
  xs: 540,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
  xxl: 1920,
  xxxl: 2560,
};

const getMinWidthMediaQuery = (breakpoint: number) => {
  return `min-width: ${breakpoint}px`;
};

export const devices: Record<Breakpoint, string> = {
  xxs: getMinWidthMediaQuery(0),
  xs: getMinWidthMediaQuery(breakpoints.xs),
  sm: getMinWidthMediaQuery(breakpoints.sm),
  md: getMinWidthMediaQuery(breakpoints.md),
  lg: getMinWidthMediaQuery(breakpoints.lg),
  xl: getMinWidthMediaQuery(breakpoints.xl),
  xxl: getMinWidthMediaQuery(breakpoints.xxl),
  xxxl: getMinWidthMediaQuery(breakpoints.xxxl),
};
